import React, {Fragment, createElement, type JSX} from 'react'

import {type RenderRecordLinkContext} from 'react-datocms/structured-text'

type RenderRecordContext = RenderRecordLinkContext<{
  __typename: string
  id: string
}>

/**
 * Persists the formatting / tags assigned to DatoCMS record links, but replaces children w/ our own
 * customized record link content.
 *
 * For example, if a content editor applies a `strong` tag to a DatoCMS Constant record link, we will keep the
 * strong tag, but replace the children with the appropriate Constant child.
 */
export const DatoRecordLink = ({
  children,
  datoChildren,
}: {
  children: JSX.Element | null
  datoChildren: RenderRecordContext['children']
}) => {
  const firstDatoChild = Array.isArray(datoChildren) ? datoChildren[0] : datoChildren
  const elementType =
    React.isValidElement(firstDatoChild) && firstDatoChild.type
      ? firstDatoChild.type
      : Fragment
  const elementProps =
    React.isValidElement(firstDatoChild) && firstDatoChild.props
      ? firstDatoChild.props
      : {}
  return createElement(elementType, elementProps, children)
}
